module.exports = __webpack_public_path__ + "static/media/washington-dc.8d1d5fab.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/geojson/washington-dc.json
// module id = 908
// module chunks = 27